import cn from '@/utils/cn'
import IconsSelectorDTP from '@/components/Molecules/IconsSelector/IconsDTP'
import IconClock from '@/components/Atoms/Icons/IconClock'
import IconDate from '@/components/Atoms/Icons/IconCalendar'
import IconDtp1 from '@/components/Atoms/Icons/IconDTPOne'
import IconDtp2 from '@/components/Atoms/Icons/IconDTPTwo'
import IconDtp3 from '@/components/Atoms/Icons/IconDtpThree'
import IconList from '@/components/Atoms/Icons/IconList'

import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import dayjs from 'dayjs'
import { DeviceType } from '@/types/enums'
import * as React from 'react'
import { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import IconDtp4 from '@/components/Atoms/Icons/IconDtpFour'
import IconDtp5 from '@/components/Atoms/Icons/IconDtpFive'

const s = cn('devices-list')

export type DtpAreaUnit = {
  id: number
  name: string
  typeId: number
  type: string
  createdDate: string
}

interface Props {
  unit: DtpAreaUnit
}

const TableViewDtpArea: FC<Props> = ({ unit }) => {
  const rawDate = unit.createdDate
  const date = dayjs(rawDate).format('DD.MM.YYYY')
  const time = dayjs(rawDate).format('HH.mm')

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        className={s()}
      >
        <TableCell
          component='th'
          scope='row'
          width={'100%'}
        >
          <Box
            display='flex'
            alignItems='end'
            gap={1}
          >
            <span
              className={s('name')}
              style={{ color: 'gray' }}
            >
              <strong>
                {unit.typeId === DeviceType.dtpRed
                  ? 'Место концентрации ДТП'
                  : 'Предочаг концентрации ДТП'}
                :
              </strong>{' '}
              {unit.name}
            </span>
          </Box>
        </TableCell>

        <TableCell
          align='right'
          sx={{
            color: '#0072BC',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '25px',
            }}
          >
            <Box
              display='flex'
              gap={2}
              alignItems='center'
              justifyContent='start'
            >
              <Box>
                {unit.typeId === DeviceType.dtpYellow && (
                  <Tooltip
                    title={'Предочаг концентрации ДТП'}
                    placement='top'
                  >
                    <div>
                      <IconDtp4 />
                    </div>
                  </Tooltip>
                )}
                {unit.typeId === DeviceType.dtpRed && (
                  <Tooltip
                    title={'Место концентрации ДТП'}
                    placement='top'
                  >
                    <div>
                      <IconDtp5 />
                    </div>
                  </Tooltip>
                )}
              </Box>
            </Box>

            <Box
              display='flex'
              gap={2}
              alignItems='center'
              justifyContent='end'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
              >
                <IconDate
                  width={20}
                  height={20}
                />
                {date}
              </Box>
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                width={100}
              >
                <IconClock
                  width={20}
                  height={20}
                />
                {time}
              </Box>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}

export default TableViewDtpArea
